var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modalContents__object06",
      attrs: { "data-modalContents": "signup04" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row no-gutters" }, [
          _c(
            "div",
            { staticClass: "col-xl-6 col-lg-8 col-md-11 col-12 mx-auto" },
            [
              _c("h2", { staticClass: "text-center" }, [
                _vm._v("MEMBERSHIP INFO.")
              ]),
              _vm._v(" "),
              _c(
                "form",
                {
                  staticClass: "row no-gutters",
                  attrs: { id: "signup04_form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.send($event)
                    }
                  }
                },
                [
                  _c("h3", { staticClass: "col-12" }, [
                    _vm._v("■ 登録者情報（登録内容をご確認ください）")
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "col-12 row no-gutters" }, [
                    _c("dt", { staticClass: "col-3" }, [_vm._v("お名前")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_name" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$store.state.inputData.last_name) +
                            " " +
                            _vm._s(_vm.$store.state.inputData.first_name)
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [_vm._v("MAIL")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_email" }
                      },
                      [_vm._v(_vm._s(_vm.$store.state.inputData.email))]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [_vm._v("TEL")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_phone" }
                      },
                      [_vm._v(_vm._s(_vm.$store.state.inputData.phone))]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [_vm._v("パスワード")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_password" }
                      },
                      [_vm._v("＊＊＊＊＊＊＊＊＊＊")]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [_vm._v("生年月日")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_birthday" }
                      },
                      [_vm._v(_vm._s(_vm.dispBirthday()))]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [_vm._v("性別")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_gender" }
                      },
                      [_vm._v(_vm._s(_vm.dispGender()))]
                    )
                  ]),
                  _vm._v(" "),
                  _c("h3", { staticClass: "col-12" }, [
                    _vm._v("■ プラン内容（登録内容をご確認ください）")
                  ]),
                  _vm._v(" "),
                  _c("dl", { staticClass: "col-12 row no-gutters" }, [
                    _c("dt", { staticClass: "col-3" }, [_vm._v("視聴プラン")]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_plan" }
                      },
                      [_vm._v(_vm._s(_vm.dispPlan()))]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [
                      _vm._v("メールマガジン")
                    ]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_mm01" }
                      },
                      [
                        _vm._v(
                          "「ニッポンの問題点」を購読" +
                            _vm._s(
                              _vm.$store.state.inputData.mm01
                                ? "する"
                                : "しない"
                            )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("dt", { staticClass: "col-3" }, [
                      _vm._v("メールマガジン")
                    ]),
                    _vm._v(" "),
                    _c(
                      "dd",
                      {
                        staticClass: "col-9",
                        attrs: { id: "signup_confirm_mm02" }
                      },
                      [
                        _vm._v(
                          "「読むオプエド」を購読" +
                            _vm._s(
                              _vm.$store.state.inputData.mm02
                                ? "する"
                                : "しない"
                            )
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm.$store.state.inputData.payment_type == "credit"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-12",
                          attrs: { id: "signup_confirm_credit" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("h3", { staticClass: "col-12" }, [
                              _vm._v(
                                "■ お支払い方法（登録内容をご確認ください）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("dl", { staticClass: "col-12 row no-gutters" }, [
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("決済方法")
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-9" }, [
                                _vm._v("PAY.jp 定期課金")
                              ]),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご請求額(税込)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_credit_price" }
                                },
                                [_vm._v(_vm._s(_vm.dispCreditPrice()) + "円")]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.$store.state.inputData.payment_type == "bank"
                    ? _c(
                        "div",
                        {
                          staticClass: "col-12",
                          attrs: { id: "signup_confirm_bank" }
                        },
                        [
                          _c("div", { staticClass: "row no-gutters" }, [
                            _c("h3", { staticClass: "col-12" }, [
                              _vm._v(
                                "■ お支払い方法（登録内容をご確認ください）"
                              )
                            ]),
                            _vm._v(" "),
                            _c("dl", { staticClass: "col-12 row no-gutters" }, [
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("決済方法")
                              ]),
                              _vm._v(" "),
                              _c("dd", { staticClass: "col-9" }, [
                                _vm._v("銀行振込")
                              ]),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("振込名義人")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_name" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$store.state.inputData.bank_name)
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご契約期間")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_month" }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$store.state.inputData.bank_month
                                    ) + "ヵ月"
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("dt", { staticClass: "col-3" }, [
                                _vm._v("ご請求額(税込)")
                              ]),
                              _vm._v(" "),
                              _c(
                                "dd",
                                {
                                  staticClass: "col-9",
                                  attrs: { id: "signup_confirm_bank_price" }
                                },
                                [_vm._v(_vm._s(_vm.dispBankPrice()) + "円")]
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 form-check modalContents__object06--privacy"
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.privacy_check,
                            expression: "privacy_check"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          name: "privacy_check",
                          id: "privacy_check"
                        },
                        domProps: {
                          checked: Array.isArray(_vm.privacy_check)
                            ? _vm._i(_vm.privacy_check, null) > -1
                            : _vm.privacy_check
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.privacy_check,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  (_vm.privacy_check = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.privacy_check = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.privacy_check = $$c
                            }
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("label", { attrs: { for: "privacy_check" } }, [
                        _vm._v("プライバシーポリシー及び利用規約に同意する")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._m(2)
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "col-12" }, [
      _vm._v("ご入力頂いた個人情報は「"),
      _c("a", { attrs: { href: "/privacy-policy.html", target: "_blank" } }, [
        _vm._v("プライバシーポリシー")
      ]),
      _vm._v("」の記載に基づいて適切に管理します。"),
      _c("br"),
      _vm._v("ご利用にあたり、「"),
      _c("a", { attrs: { href: "/policy.html", target: "_blank" } }, [
        _vm._v("利用規約")
      ]),
      _vm._v("」を必ずご確認ください。"),
      _c("br"),
      _vm._v(
        "「プライバシーポリシー」及び「利用規約」に同意の上、入力情報を送信して下さい。"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c(
        "button",
        {
          staticClass:
            "text-center btn modalContents__object06--submit globalModal--btn",
          staticStyle: { opacity: "0.5" },
          attrs: {
            id: "signup_submit",
            "data-modal": "signupSubmit",
            type: "submit"
          }
        },
        [_vm._v("登録")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "col-12 row no-gutters" }, [
      _c("li", { staticClass: "col-12" }, [
        _vm._v("「登録」ボタンは1度だけクリックしてください。"),
        _c("br"),
        _vm._v(
          "複数回クリックすると有料プランの場合重複して決済されてしまう可能性があります。"
        ),
        _c("br"),
        _vm._v(
          "次の画面に移動する間にブラウザを閉じたり、ブラウザの「戻る」ボタンをクリックしないでください。"
        )
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "col-12" }, [
        _c("strong", [_vm._v("表示金額は税込の金額")]),
        _vm._v("になります。")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "col-12" }, [
        _vm._v("カード決済を選択された場合、毎月1日の決済となります。")
      ]),
      _vm._v(" "),
      _c("li", { staticClass: "col-12" }, [
        _vm._v(
          "銀行振込を選択された場合、ブロンズ会員以上のお申し込みの方には、ご登録後に"
        ),
        _c("strong", [
          _vm._v("お振込方法などを詳しく説明したメールをお送りいたします。")
        ]),
        _vm._v(
          "入金確認まではブロンズ会員として、ニューズ・オプエドをお楽しみください。"
        )
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfa9a474", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfa9a474","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/regist_confirm.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-cfa9a474","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/vue/component/modal/regist_confirm.vue
// module chunks = 0